"use client"

import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import api from "../utils/api"
import { clearAuthAndAdminSession } from "../utils/adminSession"

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token")
      if (!token) {
        clearAuthAndAdminSession()
        setIsLoading(false)
        return navigate("/login")
      }
      try {
        const res = await api.get('/auth/me')
        if (res?.data?.locked) {
          // User is authenticated but locked: send to locked page
          setIsAuthenticated(true)
          setIsLoading(false)
          return navigate('/locked')
        }
        setIsAuthenticated(true)
      } catch {
        clearAuthAndAdminSession()
        navigate('/login')
      } finally {
        setIsLoading(false)
      }
    }

    checkAuth()
  }, [navigate])

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #ecfdf5 0%, #ffffff 50%, #f0fdf4 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "64px",
              height: "64px",
              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
              borderRadius: "16px",
              marginBottom: "16px",
              animation: "pulse 2s infinite",
            }}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M9 12l2 2 4-4" />
              <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c2.35 0 4.48.9 6.07 2.38" />
            </svg>
          </div>
          <p style={{ color: "#6b7280", margin: 0 }}>Verifying access...</p>
        </div>

        <style>
          {`
            @keyframes pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.5; }
            }
          `}
        </style>
      </div>
    )
  }

  return isAuthenticated ? children : null
}

export default PrivateRoute
